<div
  class="listing-type__label px-3 text-xs py-1 rounded-full"
  [ngClass]="[typeClass]"
>
  {{ type | insertSpace }}
</div>
